<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="auth-wrapper">
  <div class="auth" [class.expanded]="expandEMR">
    <mat-card class="auth-container" [class.sso]="!isSSOPage">
      <rx-icon name="RxPhoto-light" size="127" class="app-logo"></rx-icon>
      <mat-card-content class="card-content" [ngClass]="{ 'partner-list': expandEMR }">
        <div class="flex" [ngClass]="{ hidden: expandEMR }" [class.expanded]="expandEMR">
          <!-- <div class="header" [ngClass]="paddingClasses">
                        
                        <div *ngIf="title" class="emr-title">EMR: {{ title }}</div>
                        
                    </div> -->

          <div class="header">
            <p>{{ title || 'Log in' }}</p>
            <div class="error-title" *ngIf="loginError">
              {{ loginError }}
            </div>
          </div>
          <div class="flex jcsb">
            <router-outlet></router-outlet>

            <!--Remember me -->

            <!-- <mat-checkbox name="remember" [formControl]="signInForm.controls['remember']" class="pb-1">
                      Remember me
                  </mat-checkbox> -->
          </div>

          <button
            class="primary partner outlined"
            [matTooltip]="'Login with EMR'"
            mat-flat-button
            (click)="toggleEMR()"
            *ngIf="!progressVisibility && !expandEMR; else select"
          >
            Integrated Partner
          </button>
          <button
            class="primary partner outlined sso-btn"
            [matTooltip]="'Login via SSO'"
            mat-flat-button
            [routerLink]="['./sso']"
            *ngIf="!progressVisibility && !expandEMR"
          >
            SSO login
          </button>
          <ng-template #select>
            <rx-icon name="new_logo1" size="127"></rx-icon>
            <p class="p10 select">Internal Partner</p>
          </ng-template>
        </div>

        <div class="emr-panel" [ngClass]="{ expanded: expandEMR, sso: !isSSOPage }" *ngIf="!isSSOPage">
          <!-- <div class="header" [ngClass]="paddingClasses">
                        <rx-icon name="new_logo1" size="127"></rx-icon>
                    </div> -->

          <p class="p10 select">Internal Partner</p>

          <div class="flex">
            <button
              class="auths"
              mat-stroked-button
              *ngFor="let auth of authList.slice(1, 5)"
              (click)="selectEMR(auth)"
            >
              {{ auth.data.title }}
            </button>
          </div>

          <p class="p10 select">External Partner</p>

          <div class="flex">
            <button class="auths" mat-stroked-button *ngFor="let auth of authList.slice(5)" (click)="selectEMR(auth)">
              {{ auth.data.title }}
            </button>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <div *ngIf="expandEMR || title || isSSOPage; else forgot">
      <div class="flex flex-nosize aic mt16 forgot">
        <a (click)="toggleEMR(true)">Back to RxPhoto Login</a>
      </div>
    </div>
    <ng-template #forgot>
      <div class="flex flex-nosize aic mt16 forgot">
        <a (click)="forgotPasswordClicked()">Forgot password?</a>
      </div>
    </ng-template>
  </div>

  <div class="auth-right">
    <ads-banner #adsBanner></ads-banner>
  </div>
</div>

<div class="privacy">
  <div class="privacy-content">
    <div class="privacy-links">
      <a href="https://www.patientnow.com/privacy-policy/" class="privacy-link" target="_blank">Privacy</a>
      <a href="https://www.patientnow.com/terms-of-service/" class="privacy-link" target="_blank">Terms</a>
      <a href="https://www.patientnow.com/privacy-policy/#Cookies" class="privacy-link" target="_blank"> Cookies </a>
    </div>
    <p>Copyright © {{ currentYear }} PatientNow LLC. All rights reserved.</p>
  </div>
</div>
